import { useSyncExternalStore, useMemo } from "react";
import { MachineService } from "@domain/services/machine.service";
import { MapService } from "@domain/services/map.service";

export function useMachineStore() {
  const store = MachineService.getStore();
  const state = useSyncExternalStore(store.subscribe, store.getState);

  const actions = useMemo(
    () => ({
      selectItem: MachineService.selectMachine.bind(MachineService),
      getMachineById: MachineService.getMachineById.bind(MachineService),
      resetFilters: () => MachineService.setFilteredTypes([]),
      setFilters: MachineService.setFilteredTypes.bind(MachineService)
    }),
    []
  );

  const hasActiveFilters = useMemo(
    () => state.filteredTypes.length > 0,
    [state.filteredTypes.length]
  );

  return {
    items: state.items,
    filteredTypes: state.filteredTypes,
    selectedId: state.selectedId,
    hasActiveFilters,
    ...actions
  };
}

export function useMapStore() {
  const store = MapService.getStore();
  const state = useSyncExternalStore(store.subscribe, store.getState);

  const actions = useMemo(
    () => ({
      setMap: MapService.setMap.bind(MapService),
      setLocation: MapService.setLocation.bind(MapService),
      setUserLocation: MapService.setUserLocation.bind(MapService),
      setVisibility: MapService.setVisibility.bind(MapService),
      setInitialized: MapService.setInitialized.bind(MapService),
      locate: MapService.getCurrentLocation.bind(MapService)
    }),
    []
  );

  return {
    map: state.map,
    location: state.location,
    userLocation: state.userLocation,
    isVisible: state.isVisible,
    hasInitialized: state.hasInitialized,
    ...actions
  };
}
